import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import LoadingPage from "../components/LoadingPage";
import { primaryStudentPublicRegister } from "../../services2/users.service";
import DotdotdotSvg from '../../svg/website/Dotdotdot';
import Footer from "./components/Footer";
import './home.css'

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export default function Home() {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    let [searchParams, setSearchParams] = useSearchParams();
    const schoolId = searchParams.get('schoolId') || ''
    const [isloading, setisloading] = useState(false);
    const [data, setData] = useState({})
    const [showRegisterError, setshowRegisterError] = useState('')
    const [isShowSuccessfulPage, setisShowSuccessfulPage] = useState(false)
    const handleCompleteRegister = async () => {
        if (!data.studentName) {
            alert('請填寫學生姓名');
            return
        }
        if (!data.studentEmail) {
            alert('請填寫學生電郵');
            return
        }
        if (!validateEmail(data.studentEmail)) {
            alert('學生電郵格式不正確');
            return
        }
        if (!data.class) { alert('請填寫班級'); return; }
        if (!data.gender) { alert('請填寫性別'); return }
        if (!data.password) { alert('請填寫密碼'); return }
        // if (!data.isAcknowledged) { alert('請閱讀並同意聲明'); return }
        if (!isReady()) return
        //start upload
        setisloading(true)

       
        const newData = {
            ...data,
            studentEmail: data.studentEmail.toLowerCase(),
        }
        let result =  await primaryStudentPublicRegister(schoolId, newData.studentName, newData.studentEmail, newData.class, newData.gender, newData.password)
        if (result?.errno) {
            setshowRegisterError(result?.message || 'error')
            setisloading(false)
            return
        } else {
            setisShowSuccessfulPage(true)
            setisloading(false)
        }
    }



    const isReady = () => {
         if(!validateEmail(data.studentEmail)) return false
         if(!data.password) return false
         if(!data.class) return false
         if(!data.gender) return false
         if(!data.studentName) return false
        //  if(!data.isAcknowledged) return false
        return true
    }

    const scrollToTop = () => {
        document.getElementById('navbar').scrollIntoView({})
    }
    useEffect(() => {
        scrollToTop()
    }, [location])

    useEffect(() => {
        if (!schoolId) {
            alert('缺少schoolId參數')
            navigate('/')
        }
    }, [schoolId])


    if (isShowSuccessfulPage) return (
        <div className="w-full h-full flex flex-col items-center bg-main justify-start p-[16px] bg-[#ddd]" style={{ overflowY: 'auto' }}>

            <div className="relative w-full max-w-[1300px]">
                <div className="relative w-full border-white border-2 p-[24px] rounded-[50px] flex flex-col justify-start items-center mt-[64px] overflow-hidden">
                    <div className='absolute bottom-0 w-full h-full' style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1, }} />
                    <div className="flex flex-col w-full items-center gap-[16px] text-center" style={{ zIndex: 2 }}>
                        <div className="font-[700] text-[32px] text-[#425596] text-center mt-[24px]">學生登記</div>

                        <div className="font-[400] d-text-28-m-22 text-[#425596] mt-[16px]">
                            <div className='text-black font-[700]' style={{ display: 'inline-block' }}>{data?.studentName}</div> ,我們衷心感謝您的註冊。
                        </div>
                        <div className="font-[400] d-text-28-m-22 text-[#425596] mt-[-16px]">
                            以下是你的登記資料
                        </div>
                        <div className="font-[400] text-[18px] text-[#425596] mt-[12px]">
                            電郵地址 &nbsp;&nbsp; {data?.studentEmail}
                        </div>
                        <div className="font-[350] d-text-28-m-22 text-[#425596] mt-[12px]">
                            您已登記成功。
                        </div>



                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <div className="w-full flex flex-col items-center justify-start bg-main pb-[64px] relative">
            <img src='./home/backdroplogo.png' className="absolute w-[50%] left-[-20px] top-[12%] d-flex-m-hidden"></img>
            <div className="relative w-full max-w-[1300px] p-[16px]">
                <div className="font-[700] text-[55px] text-[#425596] text-center flex flex-row items-start justify-center">
                    學生登記
                    <DotdotdotSvg />
                </div>
            </div>

            <div className="relative w-full max-w-[1300px] p-[16px]">
                <div className="font-[500] text-[20px] text-[#425596] text-center mt-[38px]">
                   「多元素養中文閱讀能力提升」計劃
                </div>
                <div className="relative w-full rounded-[50px] flex flex-col justify-center items-center mt-[64px] overflow-hidden">
                    <div className='absolute w-full h-full top-0 left-0 bg-[#FFFFFFE5]' style={{ zIndex: 0, opacity: 0.6 }}></div>
                    <div className="flex flex-col w-full items-center gap-[16px] py-[69px] max-w-[1400px] BgGlass" style={{ zIndex: 2 }}>

                        {showRegisterError &&
                            <div className="text-[red] font-[600] text-[28px] flex flex-row items-left w-full w-full px-[50px]">
                                {showRegisterError}
                            </div>
                        }

                        <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">學生名稱<span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                    <input onChange={(e) => { setData({ ...data, studentName: e.target.value }) }} value={data?.studentName || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                </div>
                            </div>
                        </div>
                     
                        <div className="w-full flex flex-row-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="flex flex-col items-start flex-1 w-full">
                                <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">班級 <span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                        <input onChange={(e) => { setData({ ...data, class: e.target.value }) }} value={data?.class || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col items-start flex-1 w-full">
                                <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">性別 <span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                        {/*男/女*/}
                                        <select onChange={(e) => { setData({ ...data, gender: e.target.value }) }} value={data?.gender || ''} className="w-full bg-[transparent]" placeholder="請填寫">
                                            <option value="" disabled>請選擇</option>
                                            <option value="男">男</option>
                                            <option value="女">女</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                       
                        <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">登記電郵<span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                    <input onChange={(e) => { setData({ ...data, studentEmail: e.target.value }) }} value={data?.studentEmail || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">密碼<span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                    <input type="password" onChange={(e) => { setData({ ...data, password: e.target.value }) }} value={data?.password || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                </div>
                            </div>
                        </div>
                       
                       

                        {/* <div className="w-full flex flex-row w-full flex-wrap px-[50px]">
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]">
                                <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">
                                    聲明 <div className="text-[12px]"></div>
                                </div>

                                <div className="flex flex-row w-full gap-[24px] text-[11px] font-[700] text-[#425596]" style={{}}>
                                    <div onClick={(e) => { setData({ ...data, isAcknowledged: !data.isAcknowledged }) }} className="min-w-[19px] min-h-[19px] max-w-[19px] max-h-[19px] rounded-[2px] p-[2px] cursor-pointer" style={{ border: '2px solid #00E9BA' }}>
                                        {(data?.isAcknowledged || false) && <div className="w-full h-full bg-[#00E9BA]"></div>}
                                    </div>
                                    <div>
                                        本人謹此聲明，本人就此項申請所提供之一切資料均屬真實有效，如有虛報本人之申請將會被取消。本人授權「多元素養中文閱讀能力提升」計劃使用本人提供之資料作統計、活動等指定用途。
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="flex flex-row items-center justify-center mt-[40px]">
                    <div onClick={handleCompleteRegister} className="max-w-[265px] px-[80px] py-[8px] register-button mt-[16px] cursor-pointer flex justify-center items-center d-text-24-m-14 font-[700] rounded-[99px] text-[#425596]" style={{ background: '#00E9BA4D', border: '3px solid #00E9BA', opacity: isReady() ? 1 : 0.3 }}>
                        登記
                    </div>
                </div>
                <div className="w-full mt-[160px] flex flex-col">
                    <Footer />
                </div>
            </div>
            {isloading && <LoadingPage />}
        </div>
    )
}